module.exports = __webpack_public_path__ + "static/media/right-middle.b9c372b8.svg";